import React, { Component } from 'react';
import { Input, Button, Form , FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { FaCircleNotch } from 'react-icons/fa';
import { setField } from '../../../Utilities/Common';
import Actions from '../../../Actions';

class ResetForm extends Component{

    constructor(props){
        super(props);
        const { url: { location: { hash } } } = props;
        const data = queryString.parse(hash);
        this.state = {email: data.user, password: '', password_reset: data.hash};
    }
    
    setField = (endpoint, option, type = 0) => {
        setField(endpoint, option, type, (dataObj) => {
            this.setState((state) => ({...state,...dataObj}));
        });
    }

    render(){
        const { email, password, password_reset } = this.state;
        const { loading: { reset: loading }, reset } = this.props;
        return (
            <Form>
                <FormGroup>
                    <Input id="email" disabled value={ email } type="email" name="email" placeholder="Email" />
                </FormGroup>
                <FormGroup>
                    <Input id="password" onChange={(event) => this.setField('password',event)} value={ password } type="password" name="password" placeholder="New Password" />
                </FormGroup>
                <FormGroup>
                    <Button disabled={ loading } onClick={() => {reset(email, password, password_reset)}} block color="primary">
                        {loading ? <FaCircleNotch className="icon-spin" style={{marginRight: '5px', verticalAlign:'text-bottom'}} />:false }
                        Reset
                    </Button>
                </FormGroup>
            </Form>
        );
    }
}

const mapStateToProps = (state) => (
    {
      loading: state.auth.loading
    }
);

export default connect(mapStateToProps, Actions.auth)(ResetForm);


// WEBPACK FOOTER //
// ./src/Components/Auth/Layout/ResetForm.js